module.exports = __webpack_public_path__ + "img/Wallet.ecffe9e3.svg";